<template>
  <div class="doc-page">
    <h1>Supervised user accounts</h1>
    <h4>What is a supervised user account?</h4>
    <h4>How do I create a supervised user account?</h4>
    <h4>How do I add another supervisor?</h4>
    <h4>What limits does a supervised account have?</h4>
    <h4>What can the account supervisor do?</h4>
  </div>
</template>